import { render, staticRenderFns } from "./studentResponseOptBar.vue?vue&type=template&id=5bc8cd09&scoped=true"
import script from "./studentResponseOptBar.vue?vue&type=script&lang=js"
export * from "./studentResponseOptBar.vue?vue&type=script&lang=js"
import style0 from "./studentResponseOptBar.vue?vue&type=style&index=0&id=5bc8cd09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc8cd09",
  null
  
)

export default component.exports